<div class="mb-4">
  <address-client-form
    (response)="responseForm($event)"
    [editItem]="item"
    [optional]="optional"
  ></address-client-form>
</div>
@if (itemsList.length > 0) {
  <div>
    <div class="tab-overflow">
      <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
        @for (column of columns; track column.keyColumn) {
          <ng-container matColumnDef="{{ column.keyColumn }}">
            <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
            <td mat-cell *matCellDef="let element">
              @if (column.keyColumn == 'action') {
                <div class="flex justify-center items-center gap-3">
                  @if (column.key.edit) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="edit"
                      (click)="selectItemEvent(element)"
                    />
                  }
                  @if (column.key.delete) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="delete"
                      (click)="deleteItemEvent(element)"
                    />
                  }
                </div>
              } @else {
                {{ element[column.key] }}
              }
            </td>
          </ng-container>
        }
        <tr
          mat-header-row
          class="style-header"
          *matHeaderRowDef="displayedColumns"
        ></tr>
        <tr
          mat-row
          class="style-row"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
    <mat-paginator #paginator [pageSize]="5"> </mat-paginator>
  </div>
}

<!--<div>-->
<!--  <table-list-form-->
<!--    [dataSource]="itemsList"-->
<!--    [columns]="columns"-->
<!--    (selectItem)="editItem($event)"-->
<!--    (deleteItem)="deleteItem($event)"-->
<!--  />-->
<!--</div>-->
